// import Vue from 'vue'
import Pusher from 'pusher-js'
// import vue from '@krnos/vue'

Pusher.logToConsole = process.env.NODE_ENV !== 'production'
window.Pusher = Pusher

// Vue.use(vue, {
//   echo: { key: '85b04c801deee10eaa5b' }
// })
